define('collections/reseller_managers',['require','collections/base','models/reseller_manager'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/reseller_manager");

    return BaseCollection.extend({
        model: Model,
        url: 'reseller-managers.json'
    });
});

